/**
 * La huella de una foto: su SHA-256 en hexadecimal.
 *
 * Se calcula al momento de disparar, sobre la imagen YA SELLADA, y viaja con
 * ella. Si el archivo se altera entre que se toma y que sube, el hash deja de
 * cuadrar y el verificador del servidor lo marca. La huella se fija al capturar,
 * no al subir: es lo que ata la evidencia a ese instante.
 *
 * Usa Web Crypto, que existe igual en el navegador y en el WebView de la APK.
 */
export async function huellaSha256(dato: Blob): Promise<string> {
  const bytes = await dato.arrayBuffer()
  const resumen = await crypto.subtle.digest('SHA-256', bytes)
  return [...new Uint8Array(resumen)].map((b) => b.toString(16).padStart(2, '0')).join('')
}
